<app-header *ngIf="authed"></app-header>
<div class="container">
  <div class="content">
    <ng-container *ngIf="authed">
      <nav
        mat-tab-nav-bar
        class="top-level-tabs"
        color="accent"
        [mat-stretch-tabs]="true"
        [tabPanel]="tabPanel"
      >
        <a
          mat-tab-link
          [routerLink]="link.link"
          routerLinkActive
          #rla="routerLinkActive"
          [active]="rla.isActive"
          *ngFor="let link of navLinks"
          ><mat-icon *ngIf="link.icon">{{ link.icon }}</mat-icon
          ><span>{{ link.label }}</span></a
        >
      </nav>
    </ng-container>

    <mat-tab-nav-panel #tabPanel>
      <router-outlet></router-outlet>
    </mat-tab-nav-panel>
  </div>
</div>

<app-footer *ngIf="authed"></app-footer>
<merri-jump-to-top [scrollBy]="350"></merri-jump-to-top>
